/*** envelope - Section Scripts ***/
document.addEventListener('DOMContentLoaded', function () {
  const debounce = function (func, delay) {
    let timeoutId;
    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  };

  const envelopes = document.querySelectorAll('.envelope__section');
  if (envelopes && envelopes.length > 0) {
    envelopes.forEach((envelope) => {
      const form = envelope.querySelector('[data-letter-form]');
      const formContainer = envelope.querySelector('[data-letter-form-container]');

      if (form && formContainer) {
        form.remove();
        formContainer.appendChild(form);
      }

      const envelopeItem = envelope.querySelector('.envelope__envelope');
      const envelopeLetterBody = envelope.querySelector('.envelope__letter-body');
      const envelopeLetterMessage = envelope.querySelector('.envelope__letter-message');
      const topFold = envelope.querySelector('.envelope__top-fold');
      const topFoldShadow = envelope.querySelector('.envelope__top-fold-shadow');
      const letterSticker = envelope.querySelector('.envelope__sticker');
      const topFoldBack = envelope.querySelector('.envelope__top-fold-backface');
      const letter = envelope.querySelector('.envelope__letter');
      const letterCloseButton = letter.querySelector('.envelope__letter-close');
      const formStylesHack = envelope.querySelector('#shopify-form-styles');

      let envelopeHeight = envelopeItem.clientHeight;
      let envelopeLetterMessageHeight = envelopeLetterMessage.clientHeight;

      const updateLetterSizings = function () {
        const letterStyles = window.getComputedStyle(letter);
        const computedPadding =
          parseInt(letterStyles.paddingTop.replace('px', '')) + parseInt(letterStyles.paddingBottom.replace('px', ''));
        envelopeHeight = envelopeItem.clientHeight + computedPadding;
        envelopeLetterMessageHeight = envelopeLetterMessage.clientHeight + computedPadding;

        gsap.set(letter, {
          height: envelopeHeight,
        });
      };

      window.addEventListener('resize', debounce(updateLetterSizings, 100));

      const config = { attributes: false, childList: true, subtree: true };

      const onFormInjection = (mutationList, observer) => {
        for (const mutation of mutationList) {
          if (mutation.type === 'childList') {
            console.log('A child node has been added or removed.');
            const embeddedForm = envelope.querySelector('form-embed');
            if (embeddedForm) {
              console.log('Form added, injecting styles...');

              if (letter) {
                updateLetterSizings();
              } else {
                console.warn('Letter not found. Skipping height update...');
              }

              if (formStylesHack) {
                const styleElement = document.createElement('style');
                const shadow = embeddedForm.shadowRoot;
                styleElement.innerHTML = formStylesHack.innerHTML;

                shadow.appendChild(styleElement);
                console.log('Custom form styles injected.');
              } else {
                console.warn('Custom form styles not found. Skipping styles injection...');
              }

              observer.disconnect();
              envelope.classList.add('envelope--ready');
            } else {
              console.warn('Form not found. Skipping height update...');
            }
          }
        }
      };

      const observer = new MutationObserver(onFormInjection);
      observer.observe(envelopeLetterBody, config);

      tl = gsap.timeline({
        paused: true,
      });

      updateLetterSizings();

      tl.to(letterSticker, {
        duration: 0.5,
        scale: 1.3,
        filter: 'blur(10px)',
        opacity: 0,
        ease: 'back.inOut(1.5)',
      })
        .addLabel('letterStickerDetached', 0.4)
        .to(
          topFold,
          {
            duration: 0.3,
            rotateX: 180,
          },
          'letterStickerDetached'
        )
        .to(
          topFoldBack,
          {
            duration: 0.3,
            rotateX: 180,
          },
          'letterStickerDetached'
        )
        .to(
          topFoldShadow,
          {
            duration: 0.3,
            rotateX: 45,
            scaleY: 2,
          },
          'letterStickerDetached'
        )
        .to(
          topFoldShadow,
          {
            opacity: 0,
            duration: 0.3,
            filter: 'blur(10px)',
          },
          'letterStickerDetached'
        )
        .set(topFold, {
          zIndex: 0,
        })
        .set(topFoldBack, {
          zIndex: 0,
        })
        .addLabel('letterOutStart', '-=0.2')
        .set(letter, {
          height: () => envelopeHeight,
        })
        .to(
          letter,
          {
            height: () => envelopeLetterMessageHeight,
            duration: 0.6,
          },
          'letterOutStart'
        )
        .to(
          letter,
          {
            duration: 0.6,
            scaleY: 0.8,
            ease: 'back.inOut(1)',
            translateY: '-100%',
          },
          'letterOutStart'
        )
        .set(letter, {
          zIndex: 40,
        })
        .to(
          letter,
          {
            y: '-10%',
            scale: 1,
            duration: 0.7,
            ease: 'back.inOut(1.5)',
            boxShadow: '0 0 100px rgba(0,0,0,0.3)',
          },
          '-=0.2'
        );

      const openCard = function (e) {
        tl.invalidate().play();
      };

      const closeCard = function (e) {
        tl.reverse();
      };

      const handleSubmit = function (e) {
        closeCard();
        e.preventDefault();
        e.target.reset();
      };

      envelopeItem.addEventListener('click', openCard);
      envelopeItem.addEventListener('submit', handleSubmit);
      envelope.addEventListener('click', function (e) {
        if (
          e.target &&
          !e.target.closest('.envelope__letter') &&
          !e.target.closest('.envelope__content') &&
          !tl.isActive()
        ) {
          closeCard();
        }
      });

      letterCloseButton.addEventListener('click', closeCard);
    });
  }
});
